// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3xWdW","col":"styles_col__2vkxN"};